import { Button } from '@factorialco/deprecated-design-system'
import { SetRegularAccessStartDateDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  employeeId: number
  onClose: () => void
}

const SetWelcomeSpaceAccessModal = ({ employeeId, onClose }: Props) => {
  const [setRegularAccessStartDate, { loading: running }] = useMutation(
    SetRegularAccessStartDateDocument,
    {
      extractorFn: (data) => data.employeesMutations.setRegularAccessStartDateEmployeesEmployee,
      update: (cache, { data }) => {
        const mutationResponse =
          data?.employeesMutations?.setRegularAccessStartDateEmployeesEmployee
        const hasRegularAccess = mutationResponse?.employee?.hasRegularAccess

        if (employeeId && hasRegularAccess !== undefined) {
          cache.modify({
            id: cache.identify({ __typename: 'EmployeesEmployee', id: employeeId }),
            fields: {
              hasRegularAccess() {
                return hasRegularAccess
              },
            },
          })
        }
      },
    }
  )

  const onSubmit = async () => {
    const result = await setRegularAccessStartDate({
      variables: { id: employeeId },
    })

    const handled = handleResult(result, (errors) => {
      if (errors) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('employees.welcome_space.modal.error'),
        })
      }
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('employees.welcome_space.modal.success'),
      })
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('employees.welcome_space.modal.title')}
      description={i18n.t('employees.welcome_space.modal.description')}
      illustration="window-user"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary" disabled={running}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('employees.welcome_space.modal.cta')}
          </Button>
        </>
      }
    />
  )
}

export default SetWelcomeSpaceAccessModal
